import guid from '@/lib/guid'
import {createProject, getProjects} from '@/models/project'
import Vue from 'vue';
export default {
  mInit(state, projects) {
    Vue.set(state, 'projects', projects);
    // state.projects
  },
  mAdd (state, project) {
    state.projects.push(project);
  },
  mCloseDialog (state, rootState) {
    state.project = createProject();
    state.dialog.open = false;
  }
};
